<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="content-sectiton">
      <div class="container">
        <div class="alert custom-alert-danger" role="alert">
          <p>
            Sorry, The invite link is no longer active!
          </p>
        </div>
      </div>
    </section>
  </nb-layout-column>
</nb-layout>
